import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "utils/api";

export interface PropertyLienTypeModel {
    id: number;
    name: string;
    description: string;
    rank: number;
    color_code: string;
}

const fetchPropertyLienTypes = async (): Promise<PropertyLienTypeModel[]> => {
    const data = await apiRequest<{
        property_lien_type: PropertyLienTypeModel[];
    }>(`/supabase/property_lien_type/select`);

    return data.property_lien_type;
};

export function usePropertyLienTypes() {
    return useQuery({
        queryKey: ["property-lien-types"],
        queryFn: () => fetchPropertyLienTypes(),
    });
}
